﻿'use strict';

angular.module('ntmApp').factory('AttendanceProjection', ['ForecastService', 'AttendanceProjectionsFilter', 'Constants', 'Utils', 'ForecastingFiltersProvider',
    function (ForecastService, AttendanceProjectionsFilter, Constants, Utils, ForecastingFiltersProvider) {

    function AttendanceProjection() {

        var self = this;

        self.filter = new AttendanceProjectionsFilter();
        self.filterData = {};

        self.filterSettings = {
            displayProp: 'value',
            attachDisplayProp: true,
            smartButtonMaxItems: 10,
            scrollableHeight: '200px',
            enableSearch: true
        };

        self.toggleFilter = function () {
            self.showFilter = !self.showFilter;
        };

        self.multiSelectEvents = {
            onItemSelect: function () {
                self.applyFilter();
            },
            onItemDeselect: function () {
                self.applyFilter();
            },
            onDeselectAll: function () {
                self.applyFilter();
            }
        };

        self.clearFilter = function (filter) {
            filter.clear();
            self.applyFilter();
        };

        self.clearAllFilters = function () {
            self.filter.clearAllFilters();
            self.applyFilter();
        };

        self.applyFilter = function () {
            self.filteredRecords = self.filter.filterItems(self.records);
        };

        self.load = function (header, selectedWeek, scenarioId, forecastMode) {

            var data = {
                dateFrom: selectedWeek.startDate,
                dateTo: selectedWeek.endDate,
                forecastMode: forecastMode,
                forecastScope: header.selectedForecastScope.id.trim(),
                scenarioBreadcrumb: scenarioId,
                forecastView: header.forecastOptionsSummary.forecastView
            };

            self.loading = true;
            ForecastService.GetAttendanceProjections(data).then(function (result) {

                if (result.success) {

                    var records = result.data.records;

                    self.dateRange = generateDateRange(selectedWeek);
                    self.records = validateItemsByDateRange(records, self.dateRange);

                    ForecastingFiltersProvider.LoadFilters().then(function (filters) {
                        self.filterData.roles = filters.staffRoleFilters;
                        Utils.AddBlankOption(self.filterData.roles);
                        self.applyFilter();
                        self.loading = false;
                    });
                }
            });
        };

        /*
        Method needed for data safety. If some date will be missed in SQL query this function will aligh proper attendanceState to proper date
        */
        function validateItemsByDateRange(records, dateRange) {

            var result = [];

            records.forEach(function (record) {

                var validatedRecord = {
                    staffName: record.staffName,
                    personId: record.personId,
                    role: record.role,
                    items: []
                };

                dateRange.forEach(function (dow) {
                    var item = findItemByDate(record, dow.date);

                    if (item) {
                        validatedRecord.items.push(item);
                    } else {
                        validatedRecord.items.push({
                            date: dow.date,
                            attendanceState: ''
                        });
                    }
                });

                result.push(validatedRecord);
            });

            return result;
        }

        function findItemByDate(record, date) {

            return record.items.firstOrDefault(function (item) {
                var itemDate = moment(item.date);

                return itemDate.year() === date.year() && itemDate.month() === date.month() && itemDate.date() === date.date();
            });
        }

        function generateDateRange(selectedWeek) {

            var daysRange = [];

            var current = selectedWeek.startDate;
            var dateTo = selectedWeek.endDate;


            do {
                var dayLabel = Constants.DayLabels.getLabel(current).toUpperCase();
                var month = current.format('M');
                var day = current.format('D');

                daysRange.push({
                    date: current,
                    label: '{0}: {1}/{2}'.format(dayLabel, month, day)
                });

                current = moment(current).add(1, 'day');

            } while (current.diff(dateTo, 'day') <= 0);

            return daysRange;
        }
    }

    return (AttendanceProjection);
}]);